import {DatePipe} from '@angular/common';
import {NgForm} from '@angular/forms';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {classToClass, classToPlain, plainToClass} from 'class-transformer';
import {ConfirmationService, SelectItem} from 'primeng/api';

import {GrowlService, UserService} from '@app/core';
import {DialogStyle40} from '@app/shared/classes/common';
import {Format} from '../../shared/enums/format.enum';
import {SysParam} from '../../shared/enums/sys-param.enum';
import {DefaultOrg} from '../enums/default-org.enum';
import {UserInfo, UserSummary} from '../classes/user';
import {CommonDataService} from '../../shared/services/common-data.service';

import {ToDoType} from '../classes/trading-partner';
import {Container, SimpleLane, ToDo, ToDoComment,} from '../classes/to-do';
import {TradingPartnerService} from '../../shared/services/trading-partner.service';
import {Validation} from '../enums/validation.enum';

/**
 * @author Nishitha Salver (Dec 14th, 2017)
 * @desc Verbage: Task => Widget ; Lane => Conatiner
 * todo list where tasks can be moved from one state to another (drag and drop). using Ng2DND third party to support drag and drop. This component performs 2 sets of add/edit/delete operation on 2 diff arrays (this.widgets and this.containers[i].widgets)
 */

@Component({
  selector: 'app-todo',
  templateUrl: './todo.component.html',
  styleUrls: ['./todo.component.css'],
  providers: [DatePipe, ConfirmationService]
})

export class TodoComponent implements OnInit {
  // standard format and validation
  DialogStyle40 = DialogStyle40;
  Format: typeof Format = Format;
  DefaultOrg: typeof DefaultOrg = DefaultOrg;

  @ViewChild('widgetForm') widgetForm: NgForm;

  dragOperation: boolean = false;               // modeled in html to enable
  widgetDialog: boolean = false;                // shows on/off task dialog
  laneDialog: boolean = false;                  // shows on/off lane dialog
  loadhtml: boolean = false;

  maxNumOfLanes: number;                        // has count of max lanes
  selectedContainerIndex: number;               // index of selected container from set of containers
  selectedWidgetIndex: number;                  // index of selected widget in a container
  selectedContainer;                            // selected container from set of containers for edit/delete
  selectedWidget: ToDo;                         // selected widget among set of widgets in a container

  laneSelected: SimpleLane;                     // contains lane metadata like id and name used in lane dropdown
  comment: ToDoComment;                         // object used to model for comments section

  containers: Container[];                      // has list of containers/lanes retrieved from backend
  container: Container;                         // object modeled to add a lane
  selectedUser: UserSummary;                       // holds selected user from autocomplete search dropdown
  suggestedUsers: UserSummary[];                // holds list of users retrieved from backend
  widgets: ToDo[];                              // has list of tasks retrieved from  backend
  widget: ToDo;                                 // object modeled in widget dialog to add/edit tasks
  containerDropdown: SelectItem[] = [];         // holds list of names of lanes retrieved from  backend
  @Input() toDoType: string;
  @Input() toDoTypeId: number;

  Validation: typeof Validation = Validation;


  display17: boolean = false;
  display18: boolean = false;
  display19: boolean = false;

  constructor(private confirmationService: ConfirmationService, private datePipe: DatePipe, private commonService: CommonDataService, private dataService: TradingPartnerService,
              private commonDataService: CommonDataService, private growl: GrowlService, public user: UserService) {
  }


  ngOnInit() {
    this.widgets = [];
    this.container = new Container();
    this.containers = [];
    this.getContainers();
    this.getMaxNumberOfLanes();
  }

  /**
   * @desc this method hits db to get maximum number of lanes that can be added
   */
  getMaxNumberOfLanes() {
    this.commonDataService.getSysParams(SysParam.ToDoMaxLanes).subscribe(res => {
      this.maxNumOfLanes = Number(res.value);
    });
  }

  helpDialogR() {
    this.display17 = true;
  }


  helpDialogS() {
    this.display18 = true;
  }


  helpDialogT() {
    this.display19 = true;
  }

  /**
   * @desc hits db to get lanes and widgets. from this.containers: containerDropdown is populated. Containers are sorted based on sequence numbers.
   * @returns this container, this.widgets are populated
   */
  getContainers() {
    this.dataService.getLanes(this.toDoType).subscribe(res => {
      let containers = plainToClass(Container, res.list);
      if (containers) {
        this.getWidgets();
        // build dropdown menu
        let containerDropdown: SelectItem[] = []
        containers.forEach(c => {
          containerDropdown.push({label: c.lane, value: c});
          c.widgets = [];
        });
        this.containerDropdown = containerDropdown;
        // this.setSeqNumInContainers(this.containers);            // remove this after test data is sorted
      }
      containers.sort(this.compare);
      this.containers = classToClass(containers);

      this.loadhtml = true;
    });
  }

  /**
   * @desc compares sequence number of container to sort and order them
   */
  compare(a, b) {
    if (a.sequenceNum < b.sequenceNum) {
      return -1;
    } else if (a.sequenceNum == b.sequenceNum) {
      return 0;
    } else {
      return 1;
    }
  }

  /**
   * @desc hits db to get list of tasks/widgets to populate this.widgets
   */
  getWidgets() {
    this.dataService.getTask(this.toDoType, this.toDoTypeId).subscribe(res => {
      this.widgets = plainToClass(ToDo, res.list);
      this.pushWidgetsToContainers();
    });
  }

  /**
   * @desc assume this.containers is properly initialized with c.widgets = [] and pushing widgets into appropriate container that they belong to.
   */
  pushWidgetsToContainers() {
    for (let w of this.widgets) {
      for (let c of this.containers) {
        if (c.id === w.taskLaneId) {
          console.warn("match found");
          this.pushWidgetInOrder(w, c.widgets);
          // c.widgets.push(w);   // without sorting
          break;
        }
      }
    }
  }

  /**
   * @desc pushing set of widgets into container based on the location/order of each widget
   * @param widget for each widget
   * @param widgets among list of widgets
   * @returns widgets sorted
   */
  pushWidgetInOrder(widget, widgets) {
    if (!widgets) {
      widgets = [];
      widgets.push(widget);
      return widgets;
    }
    widgets.splice(this.locationOfWidget(widget, widgets) + 1, 0, widget);
    return widgets;
  }

  /**
   * @desc this method user quick sort algorithm to find the index/position of each widget and returns to calling function
   * @param widget for each widget
   * @param widgets list of widgets in a container
   * @param start start index
   * @param end length of widgets
   * @returns the location of widget
   */
  locationOfWidget(widget, widgets, start?, end?) {
    start = start || 0;
    end = end || widgets.length;
    let pivot = parseInt(start + (end - start) / 2, 10);
    console.log(`pivot = ${pivot}. widgets and widget = `);
    console.log(widgets);
    console.log(widget);
    if (!widgets[pivot] || widgets[pivot].sequenceNum === widget.sequenceNum) {
      return pivot;
    }
    if (end - start <= 1) {
      return widgets[pivot].sequenceNum > widget.sequenceNum ? pivot - 1 : pivot;
    }
    if (widgets[pivot].sequenceNum < widget.sequenceNum) {
      return this.locationOfWidget(widget, widgets, pivot, end);
    } else {
      return this.locationOfWidget(widget, widgets, start, pivot);
    }
  }

  /**
   * @desc setting sequence for widgets for each container
   * @param widgets input passed from calling function
   */
  setSeqNumInWidgets(widgets: Array<ToDo>) {
    // this sets sequenceNumber = widget index
    for (let i = 0; i < widgets.length; i++) {
      widgets[i].sequenceNum = i;
    }
  }

  /**
   * @desc looping through each container to sort its widgets
   * @param containers input passed from calling function
   */
  setSeqNumInContainers(containers: Array<Container>) {
    for (let c of containers) {
      this.setSeqNumInWidgets(c.widgets);
    }
  }

  /**
   * @desc retrieves list of users from db to populate this.users
   * @param user string types in autocomplete search
   */
  searchUser(user) {
    this.commonService.searchUserByName(user).subscribe(res => {
      this.suggestedUsers = plainToClass(UserSummary, res.list);
    });
  }

  /**
   * @desc selected user metadata is assigned to this.widget to form payload
   */
  userSelected(user: UserInfo) {
    this.widget.assignedToName = user.fullName;
    this.widget.assignedToId = user.id;
    this.widget.assignedById = this.user.info.userId;
  }


  /**
   * @desc duedate selected from p-calendar is transformed
   * @param duedate user input from p-calendar
   */
  dueDateSelected(duedate) {
    duedate = this.datePipe.transform(new Date(duedate), 'yyyy-MM-dd');
  }

  /**
   * @desc when lane selected  form dropdown, metadata is added of lane is assigned to widget to form payload
   * @param lane user input from dropdown
   */
  onLaneSelect(lane: Container) {
    this.widget.taskLaneId = lane.id;
    this.widget.taskLaneName = lane.lane;
  }

  /**
   * @desc when drag of container occurs,  sequence number is set and is saved ro db to persist. from response we get, looping through container and widgets to push widget to appropriate container, and then sorted
   */
  moveContainer(containerIndex: number) {
    this.setContainerSeqNum(this.containers);
    this.dataService.updateLanes(classToPlain(this.containers, {excludePrefixes: ['widgets']})).subscribe(res => {
      let containers = plainToClass(Container, res);
      if (containers) {
        for (let r of containers) {
          r.widgets = [];
          for (let w of this.widgets) {
            if (r.id == w.taskLaneId) {
              r.widgets.push(w);
            }
          }
          r.widgets.sort(this.compare);                    //sorting widgets in containers
        }
        containers.sort(this.compare);
      }
      this.containers = classToClass(containers);
    });
  }

  /**
   * @desc setting sequence number for containers
   */
  setContainerSeqNum(containers: Array<Container>) {
    for (let c = 0; c < containers.length; c++) {
      containers[c].sequenceNum = c;
    }
  }

  //CRUD operations on Widget*******************************************************

  /**
   * @desc opens up a dialog to add new widget info
   */
  showAddWidget() {
    if (this.widgetForm) {
      this.widgetForm.reset();
    }
    this.widget = new ToDo();
    this.comment = new ToDoComment();
    this.widget.taskTodoComments = [];
    this.widget.reminder = false;
    this.laneSelected = new SimpleLane();
    this.selectedUser = new UserSummary();
    this.widgetDialog = true;
  }

  /**
   * @desc this method accommodate common components metadata to form payload
   */
  setRespectiveToDoTypeId() {
    if (this.toDoType == ToDoType.Vendor) {
      this.widget.vendorId = this.toDoTypeId;
    }
    if (this.toDoType == ToDoType.Customer) {
      this.widget.customerId = this.toDoTypeId;
    }
    if (this.toDoType == ToDoType.Project) {
      this.widget.projectId = this.toDoTypeId;
    }
    if (this.toDoType == ToDoType.Contract) {
      this.widget.contractId = this.toDoTypeId;
    }
    if (this.toDoType == ToDoType.ProjectEstimate) {
      this.widget.projectEstimateId = this.toDoTypeId;
    }
  }

  /**
   * @desc when drag and drop of task/widget occurs, this function is invoked. this.setSeqNumInWidgets() is invoked to refreshes sequence number after every drag/drop in both From and To containers and hits db to persist
   * @param event drag event which has lane data
   * @param containerIndex index of  container from which widget is dragged
   * @param widgetIndex index of widget that is dragged
   */
  moveWidget(event: any, containerIndex: number, widgetIndex: number) {
    console.log(`movingWidget: event id = ${event.id} containerIndex = ${containerIndex} widgetIndex = ${widgetIndex}`);
    const fromLaneId = event.taskLaneId;              //id of the source container from where widget is dragged
    event.taskLaneId = this.containers[containerIndex].id;
    event.taskLaneName = this.containers[containerIndex].lane;

    // set seqNum of the widgets in the container that the widget was moved from
    const index = this.containers.findIndex(i => i.id === fromLaneId);
    this.setSeqNumInWidgets(this.containers[index].widgets);

    // set seqNum of the widgets in the container that the widget was moved to
    this.setSeqNumInWidgets(this.containers[containerIndex].widgets);

    //sending set of tasks to update
    this.dataService.updateTasks(this.containers[containerIndex].widgets).subscribe(res => {
      this.containers[containerIndex].widgets = plainToClass(ToDo, res);
    });
  }

  /**
   * @desc when deleting a widget, confirmation is provided, if YES clicked, then it successfully deleted from db
   */
  deleteWidget(widget: ToDo) {
    this.confirmationService.confirm({
      message: `Are you sure that you want to delete ${widget.title} Task?`,
      header: 'Delete Task Confirmation',
      accept: () => {
        this.dataService.deleteTask(widget.id).subscribe(res => {
          const i = this.selectedContainer.widgets.findIndex(i => i.id === widget.id);
          this.selectedContainer.widgets.splice(i, 1);                      // delete from containers
          const index = this.widgets.findIndex(i => i.id === this.selectedWidget.id);
          this.widgets.splice(index, 1);
          this.growl.add('success', ' Task deleted');
          this.setSeqNumInWidgets(this.containers[this.selectedContainerIndex].widgets);
          this.widgetDialog = false;
        });
      },
      reject: () => {
      }
    });
  }

  /**
   * @desc when task/widget is opened to edit. user service is hit to render user selected on open of dialog.     this.widget.taskTodoComments.sort(this.sortCommentsByDate) is invoked to sort all the comments by date.
   * @param containerIndex widget selected from container's index
   * @param widgetIndex index of the widget selected to edit
   */
  showEditWidget(containerIndex: number, widgetIndex: number) {
    // this.widget = new ToDo();
    this.selectedContainerIndex = containerIndex;
    this.selectedContainer = this.containers[this.selectedContainerIndex];
    this.selectedWidgetIndex = widgetIndex;
    this.selectedWidget = this.selectedContainer.widgets[this.selectedWidgetIndex];
    console.log(this.selectedWidget);

    //to bind assigned to name
    this.commonDataService.getUserById(this.selectedWidget.assignedToId).subscribe(res => {
      this.selectedUser = res;
    });
    this.widget = classToClass(this.selectedWidget);
    // Object.assign(this.widget, this.selectedWidget);
    this.widget.taskTodoComments.sort(this.sortCommentsByDate);
    this.widget.taskTodoComments.sort();
    this.comment = new ToDoComment();
    this.widgetDialog = true;
  }

  /**
   * @desc sorts  all the comments by date.
   */
  sortCommentsByDate = function (date1, date2) {
    if (date1.displayCreatedOn > date2.displayCreatedOn) {
      return -1;
    }
    if (date1.displayCreatedOn < date2.displayCreatedOn) {
      return 1;
    }
    return 0;
  };

  /**
   * @desc adds/pushes widget and its info to the selected lane/container. if container has no widgets/tasks, then it is initialized to []. this.setRespectiveToDoTypeId() us invoked to accommodate common components metadata to form payload and then hits  db to persist widget.
   * @param widget object modeled in dialog
   */
  addWidget(widget: ToDo) {
    const index = this.containers.findIndex(i => i.id === widget.taskLaneId);
    if (this.comment && this.comment.comment && this.comment.comment.length > 0) {
      this.comment.version = 0;
      this.comment.userId = this.user.info.userId;
      if (!this.containers[index].widgets) {
        this.containers[index].widgets = [];
      }
      widget.taskTodoComments.unshift(this.comment);
    }
    this.setRespectiveToDoTypeId();
    widget.subtype = this.toDoType;
    widget.completed = false;
    widget.sequenceNum = this.containers[index].widgets.length;
    this.dataService.addTask(widget).subscribe(res => {
      this.containers[index].widgets.push(plainToClass(ToDo, res as ToDo));         //pushing into container array
      this.widgets.push(plainToClass(ToDo, res as ToDo));                           //pushing to @input widget
      this.widgetDialog = false;
    });
  }

  /**
   * @desc this.comment is populated with metadata. and every new comment is pushed into existing comments array of the selected widget
   */
  updateWidget() {
    if (this.comment && this.comment.comment && this.comment.comment.length > 0) {
      this.comment.displayCreatedOn = new Date();
      this.comment.userId = this.user.info.userId;
      this.comment.userFullName = this.user.info.fullName;
      this.comment.version = 0;
      this.comment.todoTaskId = this.widget.id;
      let tempComment = new ToDoComment();
      Object.assign(tempComment, this.comment);
      this.widget.taskTodoComments.unshift(tempComment);
    }
    this.dataService.updateOneTask(this.widget, this.widget.id).subscribe(res => {    //updating in widgets[]
      Object.assign(this.containers[this.selectedContainerIndex].widgets[this.selectedWidgetIndex], plainToClass(ToDo, res as ToDo));   //updating in container[i].widgets[]
      this.growl.add('success', ' Task updated');
      this.widgetDialog = false;
    });
  }

  /**
   * @desc opens up dialog to add new lane/container
   */
  showAddContainer() {
    this.container = new Container();
    this.laneDialog = true;
  }

  /**
   * @desc container objected is modeled i template and hits db to save the record. and then this.setContainerSeqNum() is invoked to reset the sequence numbers.
   */
  addContainer() {
    this.container.taskCompletion = false;
    this.container.sequenceNum = this.containers.length;
    this.container.entityType = this.toDoType;
    this.dataService.saveLane(classToPlain(this.container, {excludePrefixes: ['name']}), this.toDoType).subscribe(res => {
      this.containers.push(plainToClass(Container, res as Container));
      this.setContainerSeqNum(this.containers);
      this.getContainers();
      this.growl.add('success', ' Lane added');
    });
    this.laneDialog = false;
  }

  /**
   * @desc when deleting a lane/container, it provides a confirmation and if YES clicked, it successfully deleted from db. if lane has tasks in it, then lane cannot be deleted. this.setContainerSeqNum() is invoked to reset the sequence numbers.
   * @param index index of the lane
   */
  deleteContainer(index: number) {
    if (this.containers[index].widgets.length != 0) {
      this.growl.add('warn', ' Lane cannot be delete as it have Tasks. Delete all tasks before deleting Lane ');
    } else {
      this.confirmationService.confirm({
        message: `Are you sure that you want to delete ${this.containers[index].lane} Lane?`,
        header: 'Delete Lane Confirmation',
        accept: () => {
          this.dataService.deleteLane(this.containers[index].id).subscribe(res => {
            this.containers.splice(index, 1);
            this.growl.add('success', ' Lane deleted');
            this.getContainers();
            this.setContainerSeqNum(this.containers);
          });
        },
        reject: () => {
        }
      });
    }
  }

}
